import { useMutation, useQueryClient } from "@tanstack/react-query"

import api from "../../services";

import cookiesHelper from "../../helpers/cookies";

import { IJobPost } from "../../interfaces/entities";
import { useNavigate, useParams } from "react-router-dom";
import useToast from "../useToast";

export interface ISaveJobPostPayload {
    setIsProcessing: React.Dispatch<React.SetStateAction<boolean>>;
    setErrorMessage: React.Dispatch<React.SetStateAction<string | null>>;
    payload: FormData;
}

const useSaveJobPost = () => {
    const navigate = useNavigate();

    const params = useParams();
    const { job_post_id } = params;

    const queryClient = useQueryClient();

    const { addToast } = useToast();

    const mutationFn = async (variables: ISaveJobPostPayload): Promise<IJobPost> => {
        const token = cookiesHelper.getCookie((process.env.REACT_APP_AUTH_TOKEN_NAME as string));
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        const { payload } = variables;

        const response = await api.put('/job-posts', payload, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });

        return response.data;
    }

    return useMutation({
        mutationFn,
        onMutate: (variables) => {
            const { setIsProcessing, setErrorMessage } = variables;
            setIsProcessing(true);
            setErrorMessage(null);
        },
        onSuccess: (data, variables) => {
            if (data) {
                const { setIsProcessing, setErrorMessage } = variables;
                setIsProcessing(false);
                setErrorMessage(null);

                if (!job_post_id) {
                    navigate(`/job-portal/${data.id}/details`);
                }

                queryClient.invalidateQueries({ queryKey: ['job-post', Number(job_post_id)] });
            }
        },
        onError: (error: any, variables) => {
            const { setIsProcessing, setErrorMessage } = variables;
            setIsProcessing(false);

            addToast({
                type: 'error',
                title: 'An error occurred while saving the job post',
            });

            setErrorMessage(error?.response?.data?.message || 'An error occurred while saving the job post');
        }
    })
}

export default useSaveJobPost;